import { delayedCall, dispatcher, IEvent, ingenuity, IObject, killDelayedCall } from "@quest/base-core";
import {
  ReelPanelController,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotEventConstants } from "@quest/slot-core";
import { EventConstantsLeander } from "@quest/oddsworks-platform";
/**
 * ReelPanelControllerGame class hanles the slot reel functionality for the base game.
 */

export class ReelPanelControllerGame extends ReelPanelController {
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.BONUS_TRAIL_COMPLETED, this.gameFlowAfterBonusTrails, this);
  }
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.BONUS_TRAIL_COMPLETED, this.gameFlowAfterBonusTrails, this);
  }

  /**
   * function to proceed game after bonus trail
   */
  private gameFlowAfterBonusTrails(): void {
    dispatcher.fireEvent(SlotEventConstants.CHECK_FOR_WIN_AFTER_REEL_STOP);
    if (!this.model.getIsWin()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
    }
  }

  protected onSpinComplete(evt?: IEvent): void {
    (ingenuity.parserModel as GameParserModel).setIsSpinClicked(false);
    ingenuity.configData.spinComplete = true;
    this.reelView.getModel().quickSpin = false;
    this.reelView.setStopNow(false);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_IS_REEL_SPINNING, false);
     if (!(ingenuity.parserModel as GameParserModel).getIsOutOfBalance()) {
    dispatcher.fireEvent(eventDispatchers.START_BONUS_SYM_TRAIL);
     } else{
      this.gameFlowAfterBonusTrails();
     }
  }

  private sendSaveDataRequest():void{
  delayedCall('sendResquest',SlotConstantsBehavior.DURATION_100,()=>{
  killDelayedCall('sendResquest');
    dispatcher.fireEvent(EventConstantsLeander.SAVE_DATA_REQUEST, this.getLeftElementData());
  })
  }

  /**
   * overide to clear trail data
   * @param evt 
   */
  protected onSpinReel(evt: IEvent): void {
    super.onSpinReel(evt);
        this.sendSaveDataRequest();
    dispatcher.fireEvent(eventDispatchers.RESET_BONUS_TRAIL_DATA);
  }

  private getLeftElementData():any {
    let UserGameData = {
      name: "SkullsDataInBroken",
      data: {
        brokenElementLevelData: {
          RedElementCount: (ingenuity.parserModel as GameParserModel).getRedElementCount(),
          BlueElementCount: (ingenuity.parserModel as GameParserModel).getBlueElementCount(),
          GreenElementCount: (ingenuity.parserModel as GameParserModel).getGreenElementCount(),
        }
      }
    };
    return UserGameData;
  }

  // Overrided to play landing animation of symbols
  protected handleScatterLanding(eventIndex: number, value: IObject): void {
    for (const element of (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()) {
      const value = element[eventIndex];
      value && dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_LANDING_SOUNDS, value);
    }
    dispatcher.fireEvent(SlotEventConstants.SHOW_LANDINGANIMATION, [this.model.getReelGrid(), this.reelView, eventIndex]);
  }

  protected onReelStoping(evt?: IEvent): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, {
      id: SoundConstant.REEL_STOP,
      key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
    });
    super.onReelStoping(evt);
  }

  // Override to apply condition, we are playing anticipation only on 5th reel when free spin trigger
  protected checkForAnticipation(symbolObj: any, listLength: number) {
    let i, j, k, n;
    let symbolCount = 0;
    let anticipation = [];
    let symbolFound = false;
    for (i = 0; i < this.reelView.getModel().numReels; i++) {
      this.reelView.getModel().anticipationSpin[i] = 0;
      if (symbolObj.aniticipationRunOnReel[i] > -1) {
        if (symbolObj.aniticipationRunOnReel[i] !== -1) {
          if (symbolCount >= symbolObj.symbolCount && symbolObj.aniticipationRunOnReel[i] !== -1) {
            if (ingenuity.configData.anticipationRunAfterFeature) {
              (ingenuity.parserModel as GameParserModel).getFSSymbolOffsets().length === 3 ? (anticipation[i] = 1) : (anticipation[i] = 0);
            } else {
              if (symbolCount >= symbolObj.symbolCount + 1) {
                anticipation[i] = 0;
              } else {
                anticipation[i] = 1;
              }
            }
          }
        }
      }
      for (j = 0; j < this.model.getReelGrid()[i].length; j++) {
        if (this.model.getReelGrid()[i][j] === symbolObj.symbolId) {
          symbolFound = true;
          break;
        }
      }
      if (symbolFound) {
        symbolCount++;
        symbolFound = false;
      }
    }
    this.anticipationList.push(anticipation);
    if (this.anticipationList.length === listLength) {
      for (k = 0; k < this.anticipationList.length; k++) {
        for (n = 0; n < this.anticipationList[k].length; n++) {
          if (this.anticipationList[k][n] === 1) {
            this.reelView.getModel().anticipationSpin[n] = 1;
          }
        }
      }
    }
    this.checkForlandingAnim(symbolObj, listLength);
  }
}
